import { ToolBarLeft } from "./components/ToolBarLeft";
import { ToolBarRight } from "./components/ToolBarRight";

/** 管理后台顶部栏，保持旧版左右工具栏布局和视觉契约。 */
export function Header() {
    return (
        <header className="layout-header">
            <ToolBarLeft />
            <ToolBarRight />
        </header>
    );
}

export default Header;
